import React from "react";
import Translate from "@src/components/translation/Translate";
import { Space, Title, BodyText, Button } from "@src/components/nessie-web";
import PrivacyMojo from "@src/assets/images/index/privacy-mojo.svg";
import CommonSense from "@src/assets/images/index/common-sense.svg";
import COPPA from "@src/assets/images/privacycenter/iKeepSafe-COPPA-seal.png";
import FERPA from "@src/assets/images/privacycenter/iKeepSafe-FERPA-seal.png";
import StudentPrivacyPledge from "@src/assets/images/privacycenter/student-privacy-pledge-signatory-badge.png";
import styled from "@emotion/styled";
import { mediaQueries } from "@src/styles/theme";
import { logEvent } from "@src/utils/logClient";

const PrivacySectionWrap = styled.section`
  width: 100%;
  margin: auto;
  margin-top: 54px;
  padding-top: 0;
  padding-bottom: 54px;

  ${mediaQueries[0]} {
    width: 750px;
    padding: 108px 15px 0px;
    margin-top: 0;
  }

  ${mediaQueries[1]} {
    width: 970px;
  }

  ${mediaQueries[2]} {
    width: 1170px;
  }
`;

const PrivacyPairBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-inline: 15px;
  gap: 30px;

  ${mediaQueries[0]} {
    flex-direction: row;
    padding-bottom: 128px;
    gap: 60px;
  }
`;

const PrivacyImgBlock = styled.div`
  max-width: 388px;
`;

const PrivacyTextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${mediaQueries[0]} {
    max-width: 360px;
    text-align: left;
    align-items: flex-start;
  }
`;

const PrivacyButton = styled(Button)`
  width: 100%;

  ${mediaQueries[0]} {
    margin-left: -18px;
    width: fit-content;
  }
`;

type PrivacySectionProps = {
  privacy_title: string;
  privacy_subtitle: string;
  privacy_link: string;
  privacy_link_label: string;
};

const PrivacySection: React.FC<PrivacySectionProps> = ({
  privacy_title,
  privacy_subtitle,
  privacy_link,
  privacy_link_label,
}) => {
  return (
    <PrivacySectionWrap>
      <PrivacyPairBlock>
        <PrivacyTextContent>
          <Title size={1}>
            <Translate path={privacy_title} />
          </Title>
          <Space size="s" />
          <BodyText>
            <Translate path={privacy_subtitle} />
          </BodyText>
          <Space size="m" />
          <PrivacyButton
            href="/privacycenter/"
            onClick={() => {
              logEvent("web.external_page.privacy_center_click");
            }}
            size="m"
            kind="tertiary"
          >
            <Translate path={privacy_link_label} />
          </PrivacyButton>
        </PrivacyTextContent>
        <PrivacyImgBlock>
          <a href="https://privacy.commonsense.org/privacy-report/ClassDojo" target="_blank" rel="noreferrer">
            <img src={CommonSense} alt="" />
          </a>
        </PrivacyImgBlock>
      </PrivacyPairBlock>
    </PrivacySectionWrap>
  );
};

export default PrivacySection;
